module.exports = __webpack_public_path__ + "static/media/hU1KxUVY_400x400.224436b0.png";